import { compose, lifecycle, withState } from 'recompose';
import Legend from './Legend';
import { studioIsKo } from '../../../utils/utils';

function componentDidMount() {
  const { setHasUnavailableData, studioData } = this.props;
  const studioWithoutData = studioData.filter(studioIsKo);
  setHasUnavailableData(!!studioWithoutData.length);
}

export default compose(
  withState('hasUnavailableData', 'setHasUnavailableData', false),
  lifecycle({ componentDidMount }),
)(Legend);



// WEBPACK FOOTER //
// src/components/googleMap/Legend/Legend.container.js